import clsx from 'clsx';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import styles from './Link.module.scss';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> | RouterLinkProps;

const isRouterLink = (props: Props): props is RouterLinkProps => props.hasOwnProperty('to');

const Link: React.FC<Props> = ({ children, ...props }) => {
  const linkProps = { ...props, className: clsx(props.className, styles.link) };

  return isRouterLink(linkProps) ? (
    <RouterLink {...linkProps}>{children}</RouterLink>
  ) : (
    <a {...linkProps}>{children}</a>
  );
};

export default Link;
